import { useSelector } from "react-redux";
import { selectIsHost } from "../../selectors";
import GuestLivePage from "./GuestLivePage";
import HostLivePage from "./HostLivePage";

/** The live page: the host gets the controller, everyone else the lyrics. */
const LivePage = () => {
  const isHost = useSelector(selectIsHost);
  return isHost ? <HostLivePage /> : <GuestLivePage />;
};

export default LivePage;
